<template>
  <a-modal
    :visible="activityVisible"
    width="702px"
    :mask-closable="false"
    :title="title"
    :confirm-loading="btnIsLoading"
    @ok="$emit('handleSubmit')"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #title>
        <a-input
          v-decorator="[
            'title',
            {
              rules: [
                {
                  required: true,
                  message: '请输入标题',
                },
              ],
            },
          ]"
          placeholder="请输入标题"
        />
      </template>
      <template #title_sub>
        <a-input
          v-decorator="[
            'title_sub',
            {
              rules: [
                {
                  required: true,
                  message: '请输入副标题',
                },
              ],
            },
          ]"
          placeholder="请输入副标题"
        />
      </template>
      <template #type>
        <a-select
          v-decorator="[
            'type',
            { rules: [{ required: true, message: '请选择消息类型' }] },
          ]"
          placeholder="请选择消息类型"
        >
          <a-select-option
            v-for="item in typeData"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </template>
      <template #company_type>
        <a-select
          v-decorator="[
            'company_type',
            { rules: [{ required: true, message: '请选择企业类型' }] },
          ]"
          placeholder="请选择企业类型"
          @change="changeCompanytype"
        >
          <a-select-option
            v-for="item in companyType"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </template>
      <template #company_id>
        <a-select
          v-decorator="[
            'company_id',
            { rules: [{ required: true, message: '请选择企业' }] },
          ]"
          placeholder="请选择企业"
        >
          <a-select-option
            v-for="item in companyData"
            :key="item.id"
            :value="item.id"
          >
            {{ item.team_name?item.team_name:item.companyInfo.qichacha_name }}
          </a-select-option>
        </a-select>
      </template>
      <template #jump_info>
        <a-textarea
          v-decorator="[
            'jump_info',
            { rules: [{ required: false, }] },
          ]"
          rows="3"
          placeholder="请输入跳转信息"
        />
      </template>
      <template #summary>
        <a-textarea
          v-decorator="[
            'summary',
            { rules: [{ required: false }] },
          ]"
          rows="3"
          placeholder="请输入消息内容"
        />
      </template>
    </basic-form>
  </a-modal>
</template>
<script>
import { formData } from '../data/index';
export default {
  props: ['activityVisible', 'title', 'btnIsLoading'],
  data() {
    return {
      formData,
      typeData: [
        {id: '0', name: '系统消息'},
        {id: '1', name: '清单消息'},
      ],
      companyType: [
        {id: '0', name: '药企'},
        {id: '1', name: '服务商'},
      ],
      companyData: [{id: '0', team_name: '所有企业'}],
      loading: false,
    };
  },
  async mounted() {
  },

  methods: {
    // 选择企业类型
    async changeCompanytype(key){
      let url;
      if(key==='0'){
        url='/company/getCompanyList';
      }else{
        url='/ServiceProvider/getCompanyList';
      }
      let result = await this.$http.post(
        url,
        {page: 0, pageSize: 0}
      );
      if(result.data.status===1){
        let data=result.data.data.data_list.filter((item)=>item.status===1);
        this.companyData=[...[{id: '0', team_name: '所有企业'}], ...data];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.client-modal-wrapper {
  .textarea {
    font-size: 12px;
    font-weight: 400;
    color: rgba(86, 92, 102, 1);
    position: relative;
    top: -37px;
    right: -550px;
  }
}
</style>
